<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import { required, minValue } from "vuelidate/lib/validators";
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import { helpers } from "../../../../helpers/helpers-validate";
import MaskedInput from "vue-text-mask";
import Switches from "vue-switches";

Vue.component("v-select", vSelect);
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
let nit = (value) => helpers.nitIsValid(value);
let correo = (value) => helpers.correo(value);

export default {
  page: {
    title: "Nueva cotización",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Switches,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      // variables nuevas
      toggleNit: false,
      arrayProductos: [],
      producto: "",
      arrayServicios: [],
      servicio: "",
      busquedaLabel2: { nombre: "Código", value: "codigo" },
      busquedaLabel: { nombre: "Nombre", value: "producto" },
      busquedaTipos: [
        { nombre: "Nombre", value: "producto" },
        { nombre: "Código", value: "codigo" },
      ],
      busquedaTipos2: [{ nombre: "Código", value: "codigo" }],
      fieldsProductos: [
        { key: "action", label: "Acciones" },
        { key: "codigo", label: "Código" },
        { key: "producto", label: "Producto" },
        { key: "existencia", label: "Existencia" },
        { key: "departamento", label: "Departamento" },
        { key: "estante", label: "Estante" },
        { key: "precio_venta", label: "Precio venta" },
      ],
      fieldsServicios: [
        { key: "action", label: "Acciones" },
        { key: "nombre_servicio", label: "Servicio" },
        { key: "descripcion_servicio", label: "Descripción" },
      ],
      fechaVec: "",
      switchCliente: true,
      formCliente: {
        nombre: "",
        apellido: "",
        nit: "C/F",
        opciones: ["MASCULINO", "FEMENINO"],
        direccion: "",
        telefono: "",
        telefono_proveedor: "",
        correo: "",
        cui: "",
        sexo: "",
        compania: "",
        direc: "",
        state: true,
        id: 0,
      },
      // variables para detalle
      ubicacionModel: 0,
      arrayEstante: [],
      estanteModel: 0,
      formget: {
        descripcion: "",
        pasillo: "",
        seccion: "",
        estante: "",
        departamentoId: "",
        id: 0,
      },
      activa_proveedor: false,
      cabezera: [
        { key: "Opciones", label: "Opciones" },
        { key: "codigo", label: "Código" },
        { key: "producto", label: "Producto" },
        { key: "existencia", label: "Existencia" },
        { key: "cantidad", label: "Cantidad", thStyle: { width: "9%" } },
        {
          key: "precio_venta",
          label: "Precio Venta",
          thStyle: { width: "20%" },
        },
        { key: "porcentaje", label: "Porcentaje descuento" },
        { key: "subtotal", label: "Subtotal" },
      ],
      cabezera2: [
        { key: "Opciones", label: "Opciones", thClass: "cell1" },
        { key: "nombre_servicio", label: "Servicio", thClass: "cell1" },
        { key: "descripcion_servicio", label: "Descripción", thClass: "cell1" },
        { key: "cantidad", label: "Cantidad", thClass: "cell1" },
        { key: "precio_venta", label: "Precio Venta", thClass: "cell1" },
        { key: "subtotal", label: "Subtotal", thClass: "cell1" },
      ],
      arrayCliente: [],
      arrayDepa: [],
      arrayClientes: [],
      apiUrl: process.env.VUE_APP_URL,
      apiBase:
        process.env.VUE_APP_URL +
        "productos/stock/busqueda?departamento=" +
        0 +
        "&estante=" +
        0,
      apiBase2: process.env.VUE_APP_URL + "servicios/select",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },

      fields2: [
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
        {
          name: "nombre_servicio",
          title: "Nombre",
        },
        {
          name: "descripcion_servicio",
          title: "Descripción",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
        },
      ],
      formPro: {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        proveedor: "",
        total: "",
        total_servicios: "",
        total_productos: "",
        state: true,
        id: 0,
      },
      data: [
        {
          nombre: "",
          cantidad: "",
          precio_compra: "",
          precio_venta: "",
          subtotal: "",
          ubicacion: "",
          sub_presentacion: "",
          button: true,
        },
      ],
      title: "NUEVA COTIZACIÓN",
      items: [
        {
          text: "Cotizaciones",
          href: "/",
        },
        {
          text: "Nueva cotización",
          active: true,
        },
      ],
      searchType: [
        { nombre: "Producto", value: "producto" },
        { nombre: "Codigo", value: "codigo" },
      ],
      searchType2: [{ nombre: "Nombre", value: "nombre" }],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_producto",
      sortDesc: false,
      searchLabel: { nombre: "Producto", value: "producto" },
      filterLabel: { nombre: "Codigo", value: "codigo" },
      searchLabel2: { nombre: "Nombre", value: "nombre" },
      filterLabel2: { nombre: "Nombre", value: "nombre" },
      showModalL: false, //Loading
      showModalNP: false, //Nuevo Proveedor
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      pageOptions: [4, 10, 15, 20],
      search: "",
      search2: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      to2: 0,
      total: 0,
      total2: 0,
      lastPage: 0,
      lastPage2: 0,
      arrayDetalle: [],
      arrayDetalleServicio: [],
      idDepartamento: 0,
      traslado_masivo: false,
      arrayDet: [],
    };
  },
  validations: {
    formCliente: {
      nombre: { required },
      apellido: { required },
      nit: { nit, required },
      direccion: { required },
      telefono: { required },
      correo: { correo, required },
      cui: { required },
      sexo: { required },
      compania: { required },
      direc: { required },
      telefono_proveedor: { required },
    },
    formPro: {
      fecha_compra: { required },
      tienda: { required },
      proveedor: { required },
      total: { required },
    },
    arrayDetalle: {
      $each: {
        subtotal: {
          required,
          minValue: minValue(1),
        },
      },
    },
    arrayDetalleServicio: {
      $each: {
        subtotal: {
          required,
          minValue: minValue(1),
        },
      },
    },
    data: { required },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.getClientes();
    this.gettienda();
    this.getFechaVec();
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
      let sum1 = 0.0;
      let sum2 = 0.0;
      let resultado = 0.0;
      if (this.arrayDetalle.length > 0) {
        for (let i = 0; i < this.arrayDetalle.length; i++) {
          if (
            this.arrayDetalle[i].subtotal == "" ||
            this.arrayDetalle[i].subtotal == null
          ) {
            sum1 = 0;
          } else {
            sum1 = parseFloat(sum1) + parseFloat(this.arrayDetalle[i].subtotal);
          }
        }
      }
      if (this.arrayDetalleServicio.length > 0) {
        for (let i = 0; i < this.arrayDetalleServicio.length; i++) {
          if (
            this.arrayDetalleServicio[i].subtotal == "" ||
            this.arrayDetalleServicio[i].subtotal == null
          ) {
            sum2 = 0;
          } else {
            sum2 =
              parseFloat(sum2) +
              parseFloat(this.arrayDetalleServicio[i].subtotal);
          }
        }
      }
      resultado = sum1 + sum2;
      return resultado.toFixed(2);
    },

    calcularProductos: function () {
      let sum1 = 0.0;
      if (this.arrayDetalle.length > 0) {
        for (let i = 0; i < this.arrayDetalle.length; i++) {
          if (
            this.arrayDetalle[i].subtotal == "" ||
            this.arrayDetalle[i].subtotal == null
          ) {
            sum1 = 0;
          } else {
            sum1 = parseFloat(sum1) + parseFloat(this.arrayDetalle[i].subtotal);
          }
        }
      }
      return sum1.toFixed(2);
    },
    calcularServicios: function () {
      let sum2 = 0;
      if (this.arrayDetalleServicio.length > 0) {
        for (let i = 0; i < this.arrayDetalleServicio.length; i++) {
          if (
            this.arrayDetalleServicio[i].subtotal == "" ||
            this.arrayDetalleServicio[i].subtotal == null
          ) {
            sum2 = 0;
          } else {
            sum2 =
              parseFloat(sum2) +
              parseFloat(this.arrayDetalleServicio[i].subtotal);
          }
        }
      }
      return sum2.toFixed(2);
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    cambiarTipo(tipo, numero) {
      if (numero == 1) {
        this.busquedaLabel = tipo;
      } else {
        this.busquedaLabel2 = tipo;
      }
    },
    swCliente() {
      this.formPro.proveedor = null;
    },
    // NUEVAS MODIFICACIONES
    async selectOpc() {
      let me = this;
      this.arrayEstante = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL +
            "departamentos/estante/busqueda?departamento=" +
            me.ubicacionModel.id,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        me.arrayEstante = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    cambioApiBase() {
      this.apiBase =
        process.env.VUE_APP_URL +
        "productos/nuevo_get?departamento=" +
        this.ubicacionModel.id +
        "&estante=" +
        this.estanteModel.id;
    },
    // fin nuevas modificaciones
    async getDepartamento() {
      const response = await axios.get(
        process.env.VUE_APP_URL +
          "departamentos/busqueda1?id=" +
          this.formPro.tiendaid,
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.arrayDepa = response.data.ubicacion;
    },

    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.formCliente.$reset();
          this.limpiarVariables();
          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
        case "productos": {
          this.arrayProductos = [];
          this.producto = "";
          break;
        }
        case "servicios": {
          this.arrayServicios = [];
          this.servicio = "";
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formCliente.id = 0;
      this.formCliente.telefono = "";
      this.formCliente.nombre = "";
      this.formCliente.nit = "C/F";
      this.formCliente.direccion = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalNP = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },
    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action) {
      if (action == "new-item") {
        this.limpiarVariables();
      }
    },
    getDatosCliente() {
      this.cambioApiBase();
    },
    async selectCliente(valor) {
      this.arrayCliente = [];
      for (var i = 0; i < this.arrayClientes.length; i++) {
        const estado = this.arrayClientes[i].nombre
          .toLowerCase()
          .includes(valor.toLowerCase());
        if (estado === true) {
          this.arrayCliente.push(this.arrayClientes[i]);
          // console.log(this.arrayProveedor)
        } else {
          // console.log("nada")
        }
      }
    },
    async gettienda() {
      let me = this;
      me.formPro.tiendaid = "";
      me.formPro.tienda = "";
      axios
        .get(process.env.VUE_APP_URL + "tiendas/select", {
          headers: { "x-token": this.userT.token },
        })
        .then(function (response) {
          me.formPro.tienda = response.data[0].nombre_tienda;
          me.formPro.tiendaid = response.data[0].id;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.getDepartamento();
        });
    },
    tomandototal() {
      let temp = 0;
      temp = parseFloat(this.calcularTotal);
      this.formPro.total = temp;
    },
    validaciones(opc) {
      this.$v.$touch();
      if (
        this.formPro.proveedor == "" ||
        this.formPro.tienda == "" ||
        this.formPro.proveedor == null
      ) {
        Vue.toasted.error("Debe agregar un cliente", this.options);
      } else {
        if (
          this.arrayDetalle.length > 0 &&
          this.arrayDetalleServicio.length == 0
        ) {
          if (this.$v.arrayDetalle.$error) {
            Vue.toasted.error("Complete los campos de productos", this.options);
          } else {
            this.showModalL = true;
            if (opc == "save") {
              this.save();
            }
          }
        }

        if (
          this.arrayDetalleServicio.length > 0 &&
          this.arrayDetalle.length == 0
        ) {
          if (this.$v.arrayDetalleServicio.$error) {
            Vue.toasted.error("Complete los campos de servicios", this.options);
          } else {
            this.showModalL = true;
            if (opc == "save") {
              this.save();
            }
          }
        }

        if (
          this.arrayDetalleServicio.length > 0 &&
          this.arrayDetalle.length > 0
        ) {
          if (
            this.$v.arrayDetalle.$error ||
            this.$v.arrayDetalleServicio.$error
          ) {
            Vue.toasted.error(
              "Complete los campos de productos y servicios",
              this.options
            );
          } else {
            this.showModalL = true;
            if (opc == "save") {
              // console.log("guarda");
              this.save();
            }
          }
        }

        if (
          this.arrayDetalleServicio.length == 0 &&
          this.arrayDetalle.length == 0
        ) {
          Vue.toasted.error("Debe agregar detalles", this.options);
        }
      }
    },
    validacionesCliente(opc) {
      // stop here if form is invalid
      this.$v.formCliente.nombre.$touch();
      this.$v.formCliente.telefono_proveedor.$touch();
      let telC = 0;
      let { nombre, telefono_proveedor } = this.formCliente;

      for (let i = 0; i < telefono_proveedor.length; i++) {
        if (telefono_proveedor[i] == "_" || telefono_proveedor[i] == "") {
          telC++;
        }
      }

      if (nombre != "" && telC == 0) {
        this.showModalL = true;
        if (opc == "save") {
          // console.log("cliente", this.formCliente);
          this.saveCliente();
        }
        if (opc == "update") {
          this.update();
        }
      } else {
        Vue.toasted.error("Complete los datos del cliente", this.options);
      }
    },
    //Guardar registro
    save() {
      const { tiendaid, fecha_compra, observaciones, proveedor, total } =
        this.formPro;
      const datos = this.arrayDetalle.map(function (item) {
        return {
          cantidad: item.cantidad,
          precio_compra: item.precio_compra,
          precio_venta: item.precio_venta,
          precio_original: item.precio_original,
          subtotal: item.subtotal,
          presentacionId: item.presentacionId,
          porcentaje: item.porcentaje_venta,
          detalle: item.id2,
          id: item.id,
          ubicacion: item.ubicacion,
        };
      });
      const datos2 = this.arrayDetalleServicio.map(function (item) {
        return {
          cantidad: item.cantidad,
          precio_venta: item.precio_venta,
          subtotal: item.subtotal,
          id: item.id,
        };
      });
      axios
        .post(
          process.env.VUE_APP_URL + "cotizaciones/store",
          {
            fecha_vencimiento: fecha_compra,
            dias_vencimiento: this.fechaVec,
            total_productos: this.calcularProductos,
            total_servicios: this.calcularServicios,
            usuario: this.userT.id,
            tienda: tiendaid,
            cliente: proveedor,
            total,
            observaciones,
            data: datos,
            data2: datos2,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Cotizacion guardada", this.options);
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error.message);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
          this.$router.push({
            name: "Cotizacion",
            shallow: true,
          });
        });
    },
    saveCliente() {
      const { nombre, nit, direccion, telefono_proveedor, correo, cui } =
        this.formCliente;
      const me = this;
      axios
        .post(
          process.env.VUE_APP_URL + "clientes/store",
          {
            nombre,
            nit,
            direccion,
            numero: telefono_proveedor,
            email: correo,
            cui,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          Vue.toasted.success(nombre + " Guardado", this.options);
          me.formPro.proveedor = response.data.clientes[0];
          me.getClientes();
          me.$refs.vuetable.refresh();
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    // Funciones para trabajar con detalles
    eliminarDetalle({ index }) {
      let me = this;
      me.arrayDetalle.splice(index, 1);
    },
    eliminarDetalleServicio({ index }) {
      let me = this;
      me.arrayDetalleServicio.splice(index, 1);
    },
    updateDisableDates({ index }) {
      const me = this;
      if (
        parseFloat(me.arrayDetalle[index].precio_venta) <
        parseFloat(me.arrayDetalle[index].precio_compra)
      ) {
        console.log(me.arrayDetalle[index].precio_venta);
        console.log(me.arrayDetalle[index].precio_compra);
        console.log(
          me.arrayDetalle[index].precio_venta <
            me.arrayDetalle[index].precio_compra
        );
        Vue.toasted.error(
          "El precio de venta es inferior el precio de compra",
          this.options
        );
        // me.arrayDetalle[index].precio_venta = me.arrayDetalle[index].precio_compra
      } else {
        me.arrayDetalle[index].subtotal =
          (me.arrayDetalle[index].cantidad != ""
            ? me.arrayDetalle[index].cantidad
            : 0.0) *
          (me.arrayDetalle[index].precio_venta != ""
            ? me.arrayDetalle[index].precio_venta
            : 0.0);
        this.$refs.table.refresh();
      }

      // item.no_extras = 0;
    },
    sumarCantidadServicio({ index }) {
      const me = this;
      // console.log(item);
      me.arrayDetalleServicio[index].subtotal =
        (me.arrayDetalleServicio[index].cantidad != ""
          ? me.arrayDetalleServicio[index].cantidad
          : 0.0) *
        (me.arrayDetalleServicio[index].precio_venta != ""
          ? me.arrayDetalleServicio[index].precio_venta
          : 0.0);
      this.$refs.table2.refresh();
      // item.no_extras = 0;
    },
    formatQuetzales(amount) {
      let num = parseFloat(amount),
        formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
    getLabel: function (val) {
      return val.nombre_departamento;
    },
    getLabel1: function (val) {
      return this.ubicacionModel.estado_tipo == 1
        ? val.nombre_estante
        : val.nombre_pasillo;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    agregarDetalle(data) {
      const me = this;
      // console.log(data);
      me.arrayDetalle.push({
        dropdownLabel: "Precio venta",
        tipos_precio: [
          {
            cantidad: data.Stock.precio_mayoreo_stock,
            nombre: "Precio mayoreo",
          },
          {
            cantidad: data.Stock.precio_taller_stock,
            nombre: "Precio taller",
          },
          { cantidad: data.Stock.precio_venta_stock, nombre: "Precio venta" },
        ],
        precio_compra: data.Stock.precio_compra_stock,
        precio_original: data.Stock.precio_venta_stock,
        precio_venta: data.Stock.precio_venta_stock,
        presentacionId: data.Stock.presentacioneId,
        validate1: false,
        validate2: false,
        presentacion: data.Stock.presentacione.nombre_presentacion,
        id: data.Stock.id,
        id2: data.id,
        codigo: data.Stock.codigo_stock,
        departamento: data.departamento.nombre_departamento,
        estante:
          data.estante.nombre_pasillo == ""
            ? data.estante.nombre_estante
            : data.estante.nombre_pasillo,
        ubicacion: data.departamentoId,
        producto: data.Stock.producto.nombre_producto,
        imagen_stock: data.Stock.imagen_stock,
        cantidad: 1,
        existencia: data.Stock.existencia_stock,
        porcentaje_venta: "",
        subtotal: data.Stock.precio_venta_stock,
      });
      this.producto = null;
      // console.log(me.arrayDetalle);
    },
    agregarDetalleServicio(data) {
      // console.log(data);
      this.arrayDetalleServicio.push({
        nombre_servicio: data.nombre_servicio,
        descripcion_servicio: data.descripcion_servicio,
        cantidad: 1,
        subtotal: 0,
        precio_venta: 0,
        id: data.id,
      });
      // console.log(this.arrayDetalleServicio);
    },
    verificarstock(stock) {
      const me = this;
      // console.log(stock)
      if (me.encuentra(stock["id"].toString())) {
        return true;
      }
    },
    verificarServicio(stock) {
      const me = this;
      // console.log(stock)
      if (me.encuentra2(stock["id"].toString())) {
        return true;
      }
    },
    // Esta función encuentra si en el detatalle ya esta la habitacion
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].id2.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },
    encuentra2(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalleServicio.length; i++) {
        if (this.arrayDetalleServicio[i].id.toString() == id) {
          sw = true;
        }
      }
      return sw;
    },

    async getClientes() {
      this.arrayClientes = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL + "clientes/busqueda",
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.arrayClientes = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getProductos(producto) {
      this.arrayProductos = [];
      if (producto == "" || producto == " ") {
        this.arrayProductos = [];
        return;
      } else {
        try {
          const response = await axios.get(
            process.env.VUE_APP_URL +
              `productos/nueva_busqueda?criterio=${this.busquedaLabel.value}&search=${producto}`,
            {
              headers: { "x-token": this.userT.token },
            }
          );
          this.arrayProductos = response.data.data;
          // console.log(this.arrayProductos);
        } catch (error) {
          console.log(error);
        }
      }
    },
    async getServicios(servicio) {
      this.arrayServicios = [];
      if (servicio == "" || servicio == " ") {
        return;
      } else {
        const response = await axios.get(
          process.env.VUE_APP_URL + `servicios/select?search=${servicio}`,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.arrayServicios = response.data.data;
        // console.log("servicios", this.arrayServicios);
      }
    },
    updateprecionuevo(data) {
      if (data.precio_venta == "") {
        data.validate1 = true;
        data.porcentaje_venta = "";
        data.subtotal =
          (data.cantidad != "" ? data.cantidad : 0.0) *
          (data.precio_venta != "" ? data.precio_venta : 0.0);
        return;
      }
      const temp = data.precio_original - data.precio_venta;
      const porcentaje = (
        (parseFloat(temp) * 100) /
        data.precio_original
      ).toFixed(2);
      if (porcentaje >= 5 && porcentaje <= 23) {
        data.validate1 = false;
        data.porcentaje_venta = porcentaje;
      } else if (porcentaje == 0) {
        data.validate1 = false;
        data.porcentaje_venta = "";
      } else {
        data.validate1 = true;
        data.porcentaje_venta = "";
      }
      if (!data.validate1) {
        data.subtotal =
          (data.cantidad != "" ? data.cantidad : 0.0) *
          (data.precio_venta != "" ? data.precio_venta : 0.0);
      } else {
        data.subtotal = 0.0;
        this.$refs.table.refresh();
      }
    },
    updateporcentaje(data) {
      console.log(data);
      if (data.porcentaje_venta == "") {
        data.validate1 = false;
        data.precio_venta = data.precio_original;
        data.subtotal =
          (data.cantidad != "" ? data.cantidad : 0.0) *
          (data.precio_venta != "" ? data.precio_venta : 0.0);
        return;
      }
      setTimeout(() => {
        if (data.porcentaje_venta < 5 || data.porcentaje_venta > 23) {
          data.validate1 = true;
          data.porcentaje_venta = "";
          if (data.dropdownTipo === 1) {
            data.precio_venta = data.tipos_precio[0].cantidad;
            data.subtotal =
              (data.cantidad != "" ? data.cantidad : 0.0) *
              (data.precio_venta != "" ? data.precio_venta : 0.0);
          }
          if (data.dropdownTipo === 2) {
            data.precio_venta = data.tipos_precio[1].cantidad;
            data.subtotal =
              (data.cantidad != "" ? data.cantidad : 0.0) *
              (data.precio_venta != "" ? data.precio_venta : 0.0);
          }
          if (data.dropdownTipo === 3) {
            data.precio_venta = data.tipos_precio[2].cantidad;
            data.subtotal =
              (data.cantidad != "" ? data.cantidad : 0.0) *
              (data.precio_venta != "" ? data.precio_venta : 0.0);
          }
          return;
        }
        data.validate1 = false;
        data.precio_venta = (
          parseFloat(data.precio_original) -
          (parseFloat(data.porcentaje_venta) / 100) *
            parseFloat(data.precio_original)
        ).toFixed(2);

        if (!data.validate1) {
          data.subtotal =
            (data.cantidad != "" ? data.cantidad : 0.0) *
            (data.precio_venta != "" ? data.precio_venta : 0.0);
        } else {
          data.subtotal = 0.0;
          this.$refs.table.refresh();
        }
      }, 700);

      // this.$refs.table.refresh();
    },
    cambiarPrecioProducto(tipo, data) {
      // console.log(tipo, data, this.arrayDetalle[data.index]);
      this.arrayDetalle[data.index].precio_original = tipo.cantidad;
      this.arrayDetalle[data.index].precio_venta =
        this.arrayDetalle[data.index].porcentaje_venta >= 5 &&
        this.arrayDetalle[data.index].porcentaje_venta <= 23
          ? (
              parseFloat(tipo.cantidad) -
              (this.arrayDetalle[data.index].porcentaje_venta / 100) *
                parseFloat(tipo.cantidad)
            ).toFixed(2)
          : parseFloat(tipo.cantidad);
      // this.arrayDetalle[data.index].porcentaje_venta = 0;
      this.arrayDetalle[data.index].dropdownLabel = tipo.nombre;
      this.arrayDetalle[data.index].dropdownTipo = tipo.tipo;
      this.arrayDetalle[data.index].subtotal =
        this.arrayDetalle[data.index].cantidad *
        this.arrayDetalle[data.index].precio_venta;
    },

    async getFechaVec() {
      this.fechaVec = "";
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL + "configuraciones/get",
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.fechaVec = response.data.data[0].dias_disponibles;

        this.formPro.fecha_compra = moment(this.formPro.fecha_compra).add(
          this.fechaVec,
          "d"
        );
        // console.log(this.formPro.fecha_compra);
      } catch (error) {
        console.log(error);
      }
    },

    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    onFiltered2() {
      this.search2 = this.search2.toLowerCase();
      this.$refs.vuetable2.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      // this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onPaginationData2(paginationData) {
      this.to2 = paginationData.to;
      this.total2 = paginationData.total;
      this.lastPage2 = paginationData.last_page;
      // this.items = paginationData.data;
      this.$refs.pagination2.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    changePageSize2() {
      this.$refs.vuetable2.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    changeTypeSearch2(type) {
      this.searchLabel2 = type;
      this.$refs.vuetable2.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    onChangePage2(page) {
      this.$refs.vuetable2.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    makeQueryParams2(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel2.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search2,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel2.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search2,
          };
    },
  },
};
</script>

<template>
  <Layout>
    <!-- Modal de Nuevo Cliente -->
    <b-modal
      centered
      @show="openModal('save')"
      @hidden="openModal('save')"
      v-model="showModalN"
      id="modalCliente"
      ref="modalCliente"
      title="Nuevo cliente"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form>
        <!-- Nombre -->
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Nombre</label>
            <input
              id="name"
              v-model="$v.formCliente.nombre.$model"
              type="text"
              class="form-control"
              placeholder="Ingrese un nombre"
              :class="{
                'is-invalid': $v.formCliente.nombre.$error,
              }"
              @input="$v.formCliente.nombre.$touch()"
            />
            <div
              v-if="
                $v.formCliente.nombre.$error && !$v.formCliente.nombre.required
              "
              class="invalid-feedback"
            >
              El nombre es obligatorio.
            </div>
          </div>
        </div>
        <!-- Identificacion -->
        <div class="col-12">
          <div class="mb-3">
            <label for="phone">Identificación</label>
            <masked-input
              v-model.trim="formCliente.cui"
              :mask="[
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]"
              class="form-control"
              placeholder="Ingrese CUI"
            />
          </div>
        </div>
        <!-- Nit -->
        <div class="col-12">
          <div class="mb-3">
            <label>Nit</label>
            <input
              v-model.trim="$v.formCliente.nit.$model"
              type="text"
              class="form-control"
              placeholder="Ingrese NIT"
            />
            <div class="alert alert-danger" v-if="!$v.formCliente.nit.nit">
              El número de NIT no es valido.
            </div>
          </div>
        </div>
        <!-- Telefono -->
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Teléfono</label>
            <masked-input
              v-model.trim="formCliente.telefono_proveedor"
              :class="{
                'is-invalid': $v.formCliente.telefono_proveedor.$error,
              }"
              :state="!$v.formCliente.telefono_proveedor.$error"
              :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
              class="form-control"
              placeholder="Ingrese el número de teléfono"
            />
            <div
              :class="{
                'invalid-feedback': true,
                'd-block':
                  $v.formCliente.telefono_proveedor.$error &&
                  !$v.formCliente.telefono_proveedor.required,
              }"
            >
              Telefono Requerido
            </div>
          </div>
        </div>
        <!-- Direccion -->
        <div class="col-12">
          <div class="mb-3">
            <label for="phone">Dirección del contacto</label>
            <input
              id="phone"
              v-model.trim="$v.formCliente.direccion.$model"
              type="text"
              class="form-control"
              placeholder="Ingrese Dirección"
            />
          </div>
        </div>
        <!-- Correo -->
        <div class="col-12">
          <div class="mb-3">
            <label for="correo">Correo</label>
            <input
              id="correo"
              v-model.trim="formCliente.correo"
              type="email"
              class="form-control"
              placeholder="Ingrese Correo"
            />
            <div
              class="alert alert-danger"
              v-if="!$v.formCliente.correo.correo"
            >
              El correo es inválido
            </div>
          </div>
        </div>
        <div class="text-end pt-5 mt-3">
          <b-button variant="light" @click="showModalN = false"
            >Cerrar</b-button
          >
          <b-button
            @click="validacionesCliente('save')"
            variant="success"
            class="ms-1"
            >Guardar</b-button
          >
        </div>
      </form>
    </b-modal>

    <!-- Modal productos -->
    <b-modal
      centered
      @show="openModal('productos')"
      @hidden="openModal('productos')"
      id="modalProductos"
      ref="modalProductos"
      title="Productos"
      size="lg"
      title-class="text-black font-18"
      body-class="p-3"
    >
      <b-form-group>
        <b-input-group>
          <b-dropdown variant="secondary" size="sm">
            <template v-slot:button-content>
              {{ busquedaLabel.nombre }}
              <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item
              v-for="(search, index) in busquedaTipos"
              :key="index"
              @click="cambiarTipo(search, 1)"
              >{{ search.nombre }}</b-dropdown-item
            >
          </b-dropdown>
          <b-input
            v-model="producto"
            placeholder="Ingrese el código o nombre del producto"
            @input="getProductos(producto)"
          >
          </b-input>
        </b-input-group>
      </b-form-group>

      <b-table striped :items="arrayProductos" :fields="fieldsProductos">
        <template #cell(action)="data">
          <b-button
            v-if="verificarstock(data.item) != true"
            @click="agregarDetalle(data.item)"
            variant="outline-primary"
            ><i class="bx bx-plus-medical"></i
          ></b-button>
        </template>
        <template #cell(producto)="data">
          {{ data.item.Stock.producto.nombre_producto }}
        </template>
        <template #cell(codigo)="data">
          {{ data.item.Stock.codigo_stock }}
        </template>
        <template #cell(existencia)="data">
          {{ data.item.existencia_departamento }}
        </template>
        <template #cell(departamento)="data">
          {{ data.item.departamento.nombre_departamento }}
        </template>
        <template #cell(estante)="data">
          {{
            data.item.estante.nombre_estante == ""
              ? data.item.estante.nombre_pasillo
              : data.item.estante.nombre_estante
          }}
        </template>
        <template #cell(precio_venta)="data">
          {{ money(data.item.Stock.precio_venta_stock) }}
        </template>
      </b-table>

      <template #modal-footer="{}">
        <b-button variant="danger" @click="$bvModal.hide('modalProductos')"
          >Cerrar</b-button
        >
      </template>
    </b-modal>

    <!-- Modal servicios -->
    <b-modal
      centered
      @show="openModal('servicios')"
      @hidden="openModal('servicios')"
      id="modalServicios"
      ref="modalServicios"
      title="Servicios"
      size="lg"
      title-class="text-black font-18"
      body-class="p-3"
    >
      <b-input
        v-model="servicio"
        placeholder="Ingrese el nombre del servicio"
        @input="getServicios(servicio)"
      >
      </b-input>
      <b-table striped :items="arrayServicios" :fields="fieldsServicios">
        <template #cell(action)="data">
          <b-button
            v-if="verificarServicio(data.item) != true"
            @click="agregarDetalleServicio(data.item)"
            variant="outline-primary"
            ><i class="bx bx-plus-medical"></i
          ></b-button>
        </template>
      </b-table>

      <template #modal-footer="{}">
        <b-button variant="danger" @click="$bvModal.hide('modalServicios')"
          >Cerrar</b-button
        >
      </template>
    </b-modal>

    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}"></template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <div class="row">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h4>NUEVA COTIZACIÓN {{ showDate(new Date()) }}</h4>
                </div>
                <div class="col" align="center">
                  <div class="mt-4 mt-sm-0">
                    <h3>
                      {{
                        formatQuetzales(formPro.total > 0 ? formPro.total : 0.0)
                      }}
                    </h3>
                    <p class="text-muted mb-2">Total</p>
                  </div>
                </div>
                <div class="col" align="right">
                  <router-link
                    target="_blank"
                    :to="{
                      name: 'nuevaCotizacion',
                    }"
                  >
                    <b-button
                      block
                      size="md"
                      variant="outline-success"
                      type="button"
                      class="btn btn-rounded mb-2 me-2"
                    >
                      <b>NUEVA PESTAÑA DE COTIZACIÓN</b>&nbsp;&nbsp;
                      <i class="bx bx-window-open"></i>
                    </b-button>
                  </router-link>
                </div>
              </div>
              <div class="text-center">
                <div align="left">
                  <div class="row">
                    <div class="col">
                      <p class="text-muted mb-2">
                        {{ switchCliente ? "Cliente" : "Cliente rápido" }}
                      </p>
                    </div>
                    <div class="col">
                      <switches
                        v-model="switchCliente"
                        class="ms-1"
                        @input="swCliente"
                      ></switches>
                    </div>
                    <div class="col"></div>
                    <div class="col"></div>
                    <div class="col" align="left">
                      <p class="text-muted mb-2">Fecha de vencimiento</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div>
                        <div v-if="switchCliente">
                          <v-select
                            v-model.trim="$v.formPro.proveedor.$model"
                            :state="!$v.formPro.proveedor.$error"
                            :options="arrayCliente"
                            @search="selectCliente"
                            placeholder="Buscar cliente..."
                            label="nombre"
                          >
                            <template slot="no-options">
                              <b-button
                                block
                                variant="primary"
                                v-b-modal.modalCliente
                                >Nuevo cliente</b-button
                              >
                            </template>
                          </v-select>
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.proveedor.$error &&
                                !$v.formPro.proveedor.required,
                            }"
                          >
                            Debe seleccionar un cliente
                          </div>
                        </div>
                        <div v-else>
                          <input
                            v-model.trim="$v.formPro.proveedor.$model"
                            :state="!$v.formPro.proveedor.$error"
                            :class="{
                              'is-invalid': $v.formPro.proveedor.$error,
                            }"
                            type="text"
                            class="form-control"
                            placeholder="Ingrese nombre del cliente"
                          />
                          <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.proveedor.$error &&
                                !$v.formPro.proveedor.required,
                            }"
                          >
                            Nombre requerido
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col d-grid">
                      <b-button
                        block
                        size="lg"
                        variant="primary"
                        v-b-modal.modalProductos
                      >
                        AGREGAR PRODUCTOS&nbsp;&nbsp;<i
                          class="bx bx-grid-alt"
                        ></i>
                      </b-button>
                    </div>
                    <div class="col d-grid gap-2">
                      <b-button
                        block
                        size="lg"
                        variant="primary"
                        v-b-modal.modalServicios
                      >
                        AGREGAR SERVICIOS&nbsp;&nbsp;<i class="bx bx-car"></i>
                      </b-button>
                    </div>
                    <div class="col" align="center">
                      <div>
                        <h4>
                          {{ showDate(formPro.fecha_compra) }}
                        </h4>
                      </div>
                    </div>
                  </div>

                  <b-table
                    small
                    striped
                    v-if="arrayDetalle.length > 0"
                    ref="table"
                    :items="arrayDetalle"
                    :fields="cabezera"
                  >
                    <template #cell(producto)="data">
                      <a
                        :href="
                          apiUrl +
                          'productos/get/imagen/' +
                          data.item.imagen_stock
                        "
                        target="_blank"
                      >
                        {{ data.item.producto }}
                      </a>
                    </template>

                    <template #cell(codigo)="data">
                      {{ data.item.codigo }}
                    </template>
                    <template #cell(opciones)="data">
                      <b-button-group>
                        <b-button
                          class="icon-content col-xl-8 col-lg-4 col-sm-"
                          size="md"
                          variant="outline-danger"
                          @click="eliminarDetalle(data)"
                          ><i :class="'bx bx-undo'" />
                        </b-button>
                      </b-button-group>
                    </template>
                    <template #cell(porcentaje)="data">
                      <b-form-input
                        @keyup="updateporcentaje(data.item)"
                        v-model="data.item.porcentaje_venta"
                        :class="{
                          'is-invalid': data.item.validate1,
                        }"
                        placeholder="Porcentaje de descuento"
                      ></b-form-input>
                      <div v-if="data.item.validate1" class="invalid-feedback">
                        El porcentaje debe estar entre 5% y 23%
                      </div>
                    </template>
                    <template #cell(precio_venta)="data">
                      <div class="input-group">
                        <b-dropdown
                          :text="data.item.dropdownLabel"
                          variant="primary"
                          :disabled="data.item.validate1"
                        >
                          <b-dropdown-item
                            v-for="(tipo, index) in data.item.tipos_precio"
                            @click="cambiarPrecioProducto(tipo, data)"
                            :key="index"
                            active
                            >{{ tipo.nombre }}
                          </b-dropdown-item>
                        </b-dropdown>
                        <b-form-input
                          @keyup="updateprecionuevo(data.item)"
                          :class="{
                            'is-invalid': data.item.validate1,
                          }"
                          v-model="data.item.precio_venta"
                          placeholder="Precio venta"
                        ></b-form-input>
                      </div>
                    </template>
                    <template #cell(subtotal)="data">
                      {{
                        formatQuetzales(
                          data.item.subtotal > 0 ? data.item.subtotal : 0.0
                        )
                      }}
                    </template>
                    <template #cell(cantidad)="data">
                      <b-form-input
                        :disabled="data.item.validate1"
                        @keyup="updateDisableDates(data)"
                        v-model="data.item.cantidad"
                        placeholder="Ingrese la cantidad"
                      ></b-form-input>
                    </template>
                    <template #cell(existencia)="data">
                      {{ data.item.existencia }}
                    </template>
                  </b-table>

                  <b-card v-if="formPro.total_productos > 0" no-body>
                    <b-row m-2>
                      <b-col align="left"
                        ><h4 align="left">
                          <i class="bx bxl-product-hunt"></i>&nbsp;&nbsp;Total
                          productos
                        </h4></b-col
                      >
                      <b-col align="right">
                        <h4>
                          {{
                            formatQuetzales(
                              formPro.total_productos > 0
                                ? formPro.total_productos
                                : 0.0
                            )
                          }}
                        </h4>
                      </b-col>
                    </b-row>
                  </b-card>

                  <h5 v-if="arrayDetalleServicio.length > 0" class="pt-3">
                    &nbsp;&nbsp;&nbsp;Servicios
                  </h5>
                  <b-table
                    striped
                    small
                    v-if="arrayDetalleServicio.length > 0"
                    ref="table2"
                    :items="arrayDetalleServicio"
                    :fields="cabezera2"
                  >
                    <template #cell(opciones)="data">
                      <b-button
                        tabindex="0"
                        v-b-tooltip.focus
                        title="Eliminar"
                        class="icon-content col-xl-8 col-lg-4 col-sm-"
                        size="md"
                        variant="outline-danger"
                        @click="eliminarDetalleServicio(data)"
                        ><i :class="'bx bx-undo'"
                      /></b-button>
                    </template>
                    <template #cell(precio_venta)="data">
                      <b-form-input
                        @keyup="sumarCantidadServicio(data)"
                        v-model="data.item.precio_venta"
                        placeholder="Precio compra"
                      ></b-form-input>
                    </template>
                    <template #cell(subtotal)="data">
                      {{
                        formatQuetzales(
                          data.item.subtotal > 0 ? data.item.subtotal : 0.0
                        )
                      }}
                    </template>

                    <template #cell(cantidad)="data">
                      <b-form-input
                        @keyup="sumarCantidadServicio(data)"
                        v-model="data.item.cantidad"
                        placeholder="Cantidad"
                      ></b-form-input>
                    </template>
                  </b-table>
                  <b-card v-if="formPro.total_servicios > 0" no-body>
                    <b-row m-2>
                      <b-col align="left"
                        ><h4 align="left">
                          <i class="bx bx-wrench"></i>&nbsp;&nbsp;Total
                          servicios
                        </h4></b-col
                      >
                      <b-col align="right">
                        <h4>
                          {{
                            formatQuetzales(
                              formPro.total_servicios > 0
                                ? formPro.total_servicios
                                : 0.0
                            )
                          }}
                        </h4>
                      </b-col>
                    </b-row>
                  </b-card>
                </div>
                <div class="col-sm-12 pt-3">
                  <div class="row">
                    <div class="col d-grid gap-2">
                      <router-link
                        class="d-grid gap-2"
                        :to="{
                          name: 'Cotizacion',
                        }"
                      >
                        <b-button
                          block
                          size="lg"
                          variant="outline-primary"
                          type="button"
                          class="btn btn-rounded mb-2 me-2"
                        >
                          <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b
                            >REGRESAR</b
                          >
                        </b-button>
                      </router-link>
                    </div>
                    <div class="col d-grid gap-2">
                      <b-button
                        block
                        size="lg"
                        variant="outline-success"
                        class="btn btn-rounded mb-2 me-2"
                        @click="validaciones('save')"
                      >
                        {{ tomandototal() }}
                        <i class="mdi mdi-truck-fast me-1"></i>
                        &nbsp;&nbsp;<b>GUARDAR</b>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end card -->
        </div>
        <!-- end col -->
      </div>
    </div>
  </Layout>
</template>
